<div
  #container
  class="fixed inset-0 z-50 flex items-center justify-center overflow-hidden"
  [class]="
    themeService.isDark()
      ? 'bg-[radial-gradient(ellipse_at_center,#0a1a2f_0%,#06101d_75%)]'
      : 'bg-[radial-gradient(ellipse_at_center,#ffffff_0%,#e7eef5_100%)]'
  "
>
  <canvas #canvas class="absolute inset-0 z-0 block h-full w-full"></canvas>

  <!-- Kinexon X -->
  <div class="pointer-events-none absolute inset-0 z-10 flex items-center justify-center">
    <svg viewBox="1362 3 328 358" width="80" height="87" overflow="visible">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#00A7E3"
        d="M1555.89 198.121H1497.23L1362.29 361.473H1414.49C1420.66 361.473 1426.44 358.776 1430.48 354.153L1511.87 259.956C1515.53 255.622 1518.61 251.48 1521.02 247.531C1523.62 243.293 1525.45 238.574 1526.51 233.758C1527.76 238.959 1529.59 243.582 1532 247.531C1534.41 251.48 1537.49 255.622 1541.15 259.956L1622.54 354.153C1626.58 358.776 1632.36 361.473 1638.52 361.473H1690.73L1555.79 198.121"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#00A7E3"
        d="M1633.04 3.94897C1626.87 3.94897 1621.09 6.64582 1617.05 11.269L1541.25 99.0127C1537.59 103.347 1534.5 107.488 1532.1 111.437C1529.5 115.675 1527.67 120.395 1526.61 125.211C1525.55 120.298 1523.62 115.675 1521.12 111.437C1518.32 107.103 1515.34 102.962 1511.97 99.0127L1435.01 9.92055C1431.74 6.16424 1427.02 3.94897 1422.01 3.94897H1367.78L1497.42 160.847H1556.08L1685.53 3.94897H1633.04Z"
      />
    </svg>
  </div>

  <!-- Corner brackets -->
  <div
    class="border-primary absolute top-6 left-6 size-4 border-t border-l md:top-20 md:left-20 xl:left-48"
  ></div>
  <div
    class="border-primary absolute right-6 bottom-6 size-4 border-r border-b md:right-20 md:bottom-20 xl:right-48"
  ></div>
  <div
    class="border-primary absolute top-6 right-6 size-4 border-t border-r md:top-20 md:right-20 xl:right-48"
  ></div>
  <div
    class="border-primary absolute bottom-6 left-6 size-4 border-b border-l md:bottom-20 md:left-20 xl:left-48"
  ></div>

  <!-- Footer: title + bouncing bar + rotating status text -->
  <div class="absolute inset-x-0 bottom-40 z-20 flex flex-col items-center gap-4">
    <div class="font-title flex gap-1 text-sm">
      <span class="text-foreground font-bold">COMPETE</span>
      <span class="text-primary tracking-wider">Vision</span>
    </div>

    <div class="flex w-48 flex-col gap-2 md:w-64 xl:w-80">
      <!-- Bouncing indeterminate progress bar -->
      <div class="bg-primary/20 relative h-0.5 overflow-hidden">
        <div
          class="bg-primary absolute inset-y-0 left-0 w-1/5 animate-[loaderBounce_1.4s_ease-in-out_infinite]"
        ></div>
      </div>

      <!-- Rotating status message -->
      <div class="text-muted-foreground flex justify-center font-mono text-xs">
        @for (msg of messages; track msg; let i = $index) {
          @if (i === messageIndex()) {
            <span class="animate-[loaderMessageIn_300ms_ease_both]">{{ msg | translate }}</span>
          }
        }
      </div>
    </div>
  </div>
</div>
